import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import { ThemeProvider } from '@mui/material/styles';
import GlobalStyles from '@mui/material/GlobalStyles';
import { bomwiseTheme, globalThemeStyles } from './theme';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';

// Components
import Header from './components/Header';
import Footer from './components/Footer';
import BOMUploadV2 from './components/BOMUploadV2';
import BOMEditor from './components/BOMEditor';
import PartSearch from './components/PartSearch';
import PricingDashboard from './components/PricingDashboard';
import ProjectList from './components/ProjectList';
import ProjectWorkspace from './components/ProjectWorkspace';
import { AuthProvider, RequireAccount, AccountForm } from './components/Auth';

function Layout({ children }) {
  const { pathname } = useLocation();
  const workspace = pathname.startsWith('/bom/') || pathname.startsWith('/projects');
  return (
    <div className="App d-flex flex-column min-vh-100">
      <Header />
      <main className={`flex-grow-1 ${workspace ? 'container-fluid bomwise-workspace-container' : 'container py-4'}`}>
        {children}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <ThemeProvider theme={bomwiseTheme}>
      <GlobalStyles styles={globalThemeStyles} />
      <Router>
        <AuthProvider><Layout>
          <Routes>
            <Route path="/login" element={<AccountForm />} />
            <Route path="/register" element={<AccountForm register />} />
            <Route path="/" element={<RequireAccount><BOMUploadV2 /></RequireAccount>} />
            <Route path="/upload" element={<RequireAccount><BOMUploadV2 /></RequireAccount>} />
            <Route path="/bom/:bomId" element={<RequireAccount><BOMEditor /></RequireAccount>} />
            <Route path="/analysis/:projectId" element={<RequireAccount><p>Legacy analysis is retired. Reimport your BOM to use the secure editor.</p></RequireAccount>} />
            <Route path="/search" element={<RequireAccount><PartSearch /></RequireAccount>} />
            <Route path="/pricing" element={<RequireAccount><PricingDashboard /></RequireAccount>} />
            <Route path="/projects" element={<RequireAccount><ProjectList /></RequireAccount>} />
            <Route path="/projects/:projectId" element={<RequireAccount><ProjectWorkspace /></RequireAccount>} />
          </Routes>
        </Layout></AuthProvider>
        <ToastContainer position="top-right" autoClose={5000} />
      </Router>
    </ThemeProvider>
  );
}

export default App;